import * as Sentry from '@sentry/browser';

function isInjectedCode(event) {
  const frames = event?.exception?.values?.[0]?.stacktrace?.frames;
  if (!frames || frames.length === 0) {
    return false;
  }

  const firstFrame = frames[0];
  return ['<anonymous>', 'Unknown', 'unknown'].includes(firstFrame.filename);
}

if (process.env.MIX_SENTRY_FRONTEND_DSN && process.env.MIX_SENTRY_FRONTEND_AUTH_TOKEN) {
  Sentry.init({
    environment: process.env.MIX_SENTRY_APP_ENV,
    dsn: process.env.MIX_SENTRY_FRONTEND_DSN,
    release: process.env.MIX_SENTRY_RELEASE,
    integrations: [Sentry.replayIntegration()],
    replaysOnErrorSampleRate: 0.01,
    sampleRate: 0.1,
    beforeSend(event) {
      if (isInjectedCode(event)) {
        return null;
      }
      return event;
    },
  });
}
